import { useCallback, useState } from 'react';
import { asyncAttempt } from '@namespace/helpers';
import { useI18n } from '@namespace/i18n';
import { useNotifications } from '@namespace/notifications';
import { getTaxesByCode } from '../../api/taxes';
import { STORE_PROPS, usePaymentsStore } from '../../store';
import { formatErrorMessage } from '../../utils';

export const useGetTaxesByCode = () => {
  const [isFetching, setIsFetching] = useState(false);
  const [isError, setIsError] = useState(false);
  const activeServiceId = usePaymentsStore(STORE_PROPS.ACTIVE_SERVICE_ID);
  const { errorNotification } = useNotifications();
  const { t, language } = useI18n();

  const loadTaxes = useCallback(
    async (voucherId: string) => {
      setIsFetching(true);
      setIsError(false);

      const [requestError, result] = await asyncAttempt(getTaxesByCode, {
        voucherId,
        serviceId: activeServiceId as number,
        lang: language
      });

      if (requestError) {
        const { errorCode } = requestError;
        errorNotification(t(formatErrorMessage(errorCode)));
        setIsError(true);
      }
      setIsFetching(false);

      return result;
    },
    [activeServiceId, errorNotification, language, t]
  );

  return {
    loadTaxes,
    isFetching,
    isError
  };
};
